import request from '@/utils/request'
const baseURL = process.env.VUE_APP_BASE_API

export const AUDITAPI = {
  // 获取所有工单统计
  getAllAudit: (params: any) => {
    return request({
      url: baseURL + 'ticket/all/audit',
      method: 'get',
      params
    })
  },
  // 获取基地工单统计
  getAreaAudit: (params: any) => {
    return request({
      url: baseURL + 'ticket/place/audit',
      method: 'get',
      params
    })
  },
   // 获取个人工单统计
  getOwnAudit: (params: any) => {
    return request({
      url: baseURL + 'ticket/waiter/audit',
      method: 'get',
      params
    })
  },
  // 获取个人发起统计数据
  getMyAudit: (params: any) => {
    return request({
      url: baseURL + 'ticket/my/audit',
      method: 'get',
      params
    })
  },
  // 获取个人受理统计数据
  getFixAudit: (params: any) => {
    return request({
      url: baseURL + 'ticket/fix/audit',
      method: 'get',
      params
    })
  },
  // 首页获取保障的统计数据
  getDashboardWaiterData: (params: any) => {
    return request({
      url: baseURL + 'ticket/waiter/dashboard',
      method: 'get',
      params
    })
  },
  // 获取系统SLA统计数据
  getSystemSLAData: (params: any) => {
    return request({
      url: baseURL + 'ticket/systemSLA',
      method: 'get',
      params
    })
  }
}
